module.exports = __webpack_public_path__ + "static/lazienka-4c09a77e9f97fb2a8b6c0de31e703bef.jpeg";